export enum SystemGroup {
  IdeaRoom = 'IdeaRoom', // Users from this group have permission to execute all operations
  GroupUser = 'GroupUser',
}
